import { AttributeValue, DynamoDBClient, GetItemCommand, PutItemCommand } from '@aws-sdk/client-dynamodb'
import { marshall, unmarshall } from '@aws-sdk/util-dynamodb'
import crypto from 'crypto'
import { CreateOneTrustEvent, onetrustEventSchema } from './schema'

export class OneTrustEventRepository {
  private client: DynamoDBClient
  private tableName = 'onetrust_events'

  constructor() {
    this.client = new DynamoDBClient({})
  }

  async create(event: CreateOneTrustEvent) {
    const id = crypto.randomUUID()

    const command = new PutItemCommand({
      TableName: this.tableName,
      Item: marshall({
        id,
        event,
        received_at: new Date().toISOString(),
      }),
    })

    await this.client.send(command)

    return { id }
  }

  async getById(id: string) {
    const command = new GetItemCommand({
      TableName: this.tableName,
      Key: marshall({ id }),
    })

    const result = await this.client.send(command)

    if (!result.Item) {
      return null
    }

    const item = unmarshall(result.Item as Record<string, AttributeValue>)

    return onetrustEventSchema.parse(item.event)
  }
}
